import { Box, Typography } from "@mui/material";
import { Control } from "react-hook-form";

import CustomTextField from "../../../../../../../../components/molecules/custom-textfield/custom-textfield";
import {
    CompanyIconSmall,
    ProjectIconSmall,
    DateIconSmall,
    CompanyIconInput,
    ProjectIconInput,
} from "./HeaderIcons";

type FormData = {
    document_title: string;
    enterprise: string;
    project: string;
};

interface IHeaderMetadataProps {
    control: Control<FormData, any>;
    company: string;
    project: string;
    date: string;
    isEditing: boolean;
}

export default function HeaderMetadata({
    company,
    control,
    project,
    date,
    isEditing,
}: IHeaderMetadataProps) {
    function parseDateAsLocal(dateString: string): Date {
        const [year, month, day] = dateString.split("-").map(Number);
        return new Date(year, month - 1, day);
    }

    if (isEditing) {
        return (
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
                    gap: 2,
                    mt: 2,
                }}
            >
                <CustomTextField
                    control={control}
                    name="enterprise"
                    fullWidth
                    label="Empresa"
                    placeholder="Nome da empresa"
                    variant="outlined"
                    size="small"
                    disabled={true}
                    InputProps={{
                        startAdornment: <CompanyIconInput />,
                    }}
                />

                <CustomTextField
                    name="project"
                    control={control}
                    fullWidth
                    label="Projeto"
                    placeholder="Nome do projeto"
                    variant="outlined"
                    size="small"
                    disabled={true}
                    InputProps={{
                        startAdornment: <ProjectIconInput />,
                    }}
                />

                {/* <TextField
                    fullWidth
                    label="Data"
                    type="date"
                    value={new Date().toISOString().split("T")[0]}
                    disabled
                    variant="outlined"
                    size="small"
                    InputProps={{
                        startAdornment: <DateIconInput />,
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                /> */}
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                alignItems: "center",
            }}
        >
            {company && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <CompanyIconSmall />
                    <Typography variant="body2">{company}</Typography>
                </Box>
            )}

            {project && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <ProjectIconSmall />
                    <Typography variant="body2">{project}</Typography>
                </Box>
            )}

            {date && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <DateIconSmall />
                    <Typography variant="body2">
                        {parseDateAsLocal(date).toLocaleDateString("pt-BR")}
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
